// ** React imports
import CustomSpinner from "../../../../components/spinners/CustomSpinner"

// ** Third Party Components
import { useFormik } from "formik"
import { X, XCircle, Plus } from "react-feather"
import Flatpickr from "react-flatpickr"
import { Mexico } from "flatpickr/dist/l10n/es"
import Select from "react-select"

// ** Reactstrap Imports
import {
  Input,
  Label,
  Button,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  UncontrolledAccordion,
  Modal
} from "reactstrap"

const PlanMedicoIndividualForm = (props) => {
  // ** State
  
  const respuestaSiNo = [
    {
      label: "Si",
      value: "Si"
    },
    {
      label: "No",
      value: "No"
    }
  ]
  const parentezco = [
    {
      label: "Conyugue",
      value: "Conyugue"
    },
    {
      label: "Hijo",
      value: "Hijo"
    },
    {
      label: "Hija",
      value: "Hija"
    },
    {
      label: "Madre",
      value: "Madre"
    },
    {
      label: "Padre",
      value: "Padre"
    }
  ]
  const coberturaOpc = [
    {
      label: "Cobertura nacional",
      value: "Cobertura nacional"
    },
    {
      label: "Cobertura internacional",
      value: "Cobertura internacional"
    }
  ]
  const sexo = [
    { label: "Hombre", value: "Hombre" },
    { label: "Mujer", value: "Mujer" }
  ]

  function initialValues() {
    if (props.accion === 1) {
      return {
        seguroMedico: "Si",
        aseguradora: "",
        sumaAsegurada: "",
        deducible: "",
        territorioCobertura: "",
        nivelHospitalario: "",
        hospitalCirugia: "",
        antiguedad: "",
        beneficiarios: [],
        razon: "",
        padecimiento: "",
        cobertura: "",
        coberturaMaternidad: ""
      }
    } else {
      return props.data
    }
  }

  function createBeneficiarioObj() {
    return {
      nombreCompleto: "",
      fechaNacimiento: "13/07/2022",
      edad: "",
      sexo: "",
      padecimiento: "Si",
      fuma: "Si",
      diabetes: "Si",
      peso: "",
      estatura: "",
      parentezco: ""
    }
  }

  const formik = useFormik({
    initialValues: initialValues(),
    //validationSchema: yup.object(validationSchema()),
    onSubmit: (data, { resetForm }) => {
      data = {
        ...data,
        accion: props.accion,
        tipo: "personal",
        nombre: "Plan médico individual",
        slug: "plan-medico-individual"
      }
      props.administrar(data, props.handleSuccess)
      resetForm()
    }
  })

  function agregarBeneficiario() {
    const beneficiariosNewIndex = formik.values.beneficiarios.length
    formik.setFieldValue(
      `beneficiarios[${beneficiariosNewIndex}]`,
      createBeneficiarioObj()
    )
  }

  function eliminarBeneficiario(index) {
    const newBeneficiarios = formik.values.beneficiarios
    newBeneficiarios.splice(index, 1)
    formik.setFieldValue("beneficiarios", newBeneficiarios)
  }

  return (
    <div>
      <Modal isOpen={props.loading}>
        <CustomSpinner />
      </Modal>
      <h1 className="mb-2 col-12 text-center">Plan médico individual</h1>

      <div>
        <div className="mb-1">
          <Label className="form-label">
            ¿Actualmente cuentas con algún seguro médico?
          </Label>

          <Select
            id="sexo"
            className="react-select w-25"
            classNamePrefix="select"
            defaultValue={respuestaSiNo[0]}
            value={{
              label: formik.values.seguroMedico,
              value: formik.values.seguroMedico
            }}
            onChange={(e) => {
              formik.setFieldValue(`seguroMedico`, e.value)
            }}
            options={respuestaSiNo}
            isClearable={false}
            isSearchable={false}
          />
        </div>

        {formik.values.seguroMedico === "Si" ? (
          <>
            <div className="mb-1">
              <Label className="form-label" htmlFor="aseguradora">
                Aseguradora
              </Label>
              <Input
                type="number"
                id="aseguradora"
                placeholder="Ingrese numero"
                value={formik.values.aseguradora}
                onChange={(e) => {
                  formik.setFieldValue("aseguradora", e.target.value)
                }}
              />
            </div>
            <div className="mb-1">
              <Label className="form-label" htmlFor="sumaAsegurada">
                Suma asegurada
              </Label>
              <Input
                type="number"
                id="sumaAsegurada"
                placeholder="Ingrese numero"
                value={formik.values.sumaAsegurada}
                onChange={(e) => {
                  formik.setFieldValue("sumaAsegurada", e.target.value)
                }}
              />
            </div>
            <div className="mb-1">
              <Label className="form-label" htmlFor="deducible">
                Deducible
              </Label>
              <Input
                type="number"
                id="deducible"
                placeholder="Ingrese numero"
                value={formik.values.deducible}
                onChange={(e) => {
                  formik.setFieldValue("deducible", e.target.value)
                }}
              />
            </div>
            <div className="mb-1">
              <Label className="form-label" htmlFor="territorioCobertura">
                Territorio de Cobertura
              </Label>
              <Input
                type="number"
                id="territorioCobertura"
                placeholder="Ingrese numero"
                value={formik.values.territorioCobertura}
                onChange={(e) => {
                  formik.setFieldValue("territorioCobertura", e.target.value)
                }}
              />
            </div>
            <div className="mb-1">
              <Label className="form-label" htmlFor="nivelHospitalario">
                Nivel hospitalario
              </Label>
              <Input
                type="number"
                id="nivelHospitalario"
                placeholder="Ingrese numero"
                value={formik.values.nivelHospitalario}
                onChange={(e) => {
                  formik.setFieldValue("nivelHospitalario", e.target.value)
                }}
              />
            </div>
            <div className="mb-1">
              <Label className="form-label" htmlFor="antiguedad">
                Antigüedad
              </Label>
              <Input
                type="number"
                id="antiguedad"
                placeholder="Ingrese numero"
                value={formik.values.antiguedad}
                onChange={(e) => {
                  formik.setFieldValue("antiguedad", e.target.value)
                }}
              />
            </div>
          </>
        ) : (
          <>
            <div className="mb-1">
              <Label className="form-label" htmlFor="razon">
                ¿Hay alguna razón?
              </Label>
              <Input
                type="textarea"
                id="razon"
                placeholder="Ingrese razon"
                value={formik.values.razon}
                onChange={(e) => {
                  formik.setFieldValue("razon", e.target.value)
                }}
              />
            </div>
          </>
        )}

        <div className="mb-1">
          <Label className="form-label" htmlFor="hospitalCirugia">
            En caso de que te atendieras algún padecimiento o enfermedad que
            requiera cirugía, ¿En que hospital lo harías?
          </Label>
          <Input
            type="text"
            id="hospitalCirugia"
            placeholder="Ingrese nombre del hospital"
            value={formik.values.hospitalCirugia}
            onChange={(e) => {
              formik.setFieldValue("hospitalCirugia", e.target.value)
            }}
          />
        </div>
        <div className="mb-1">
          <Label className="form-label" htmlFor="cobertura">
            ¿Ocuparías una cobertura internacional o prefieres una cobertura
            nacional a menor costo
          </Label>

          <Select
            className="react-select w-50"
            classNamePrefix="select"
            defaultValue={coberturaOpc[0]}
            value={
              formik.values.cobertura != ""
                ? {
                    label: formik.values.cobertura,
                    value: formik.values.cobertura
                  }
                : coberturaOpc[0]
            }
            onChange={(e) => {
              formik.setFieldValue("cobertura", e.value)
            }}
            options={coberturaOpc}
            isClearable={false}
            isSearchable={false}
          />
        </div>
        <div className="mb-1">
          <Label className="form-label" htmlFor="cobertura">
            ¿A quiénes te interesa darles el beneficio?
          </Label>

          {formik.values.beneficiarios.length > 0 &&
            formik.values.beneficiarios.map((_currentValue, index) => (
              <div className="d-flex my-2" key={index}>
                <UncontrolledAccordion
                  style={{ width: "95%" }}
                  defaultOpen={[]}
                  stayOpen
                >
                  <AccordionItem>
                    <AccordionHeader targetId="1">
                      Beneficiario {index + 1}
                    </AccordionHeader>
                    <AccordionBody accordionId="1">
                      <div className="mb-1">
                        <Label className="form-label" htmlFor="nombre">
                          Nombre completo
                        </Label>
                        <Input
                          id="nombre"
                          type="text"
                          value={
                            formik.values.beneficiarios[index]["nombreCompleto"]
                          }
                          onChange={(e) => {
                            formik.setFieldValue(
                              `beneficiarios[${index}].nombreCompleto`,
                              e.target.value
                            )
                          }}
                        />
                      </div>
                      <div className="mb-1">
                        <Label className="form-label" htmlFor="fecha">
                          Fecha de nacimiento
                        </Label>

                        <Flatpickr
                          className="form-control"
                          localName={Mexico}
                          value={
                            formik.values.beneficiarios[index][
                              "fechaNacimiento"
                            ]
                          }
                          onChange={(_selectedDates, dateString) => {
                            formik.setFieldValue(
                              `beneficiarios[${index}].fechaNacimiento`,
                              dateString
                            )
                          }}
                          id="fecha"
                          options={{ dateFormat: "d/m/Y" }}
                        />
                      </div>
                      <div className="mb-1">
                        <Label className="form-label" htmlFor="edad">
                          Edad
                        </Label>
                        <Input
                          id="edad"
                          type="number"
                          value={formik.values.beneficiarios[index]["edad"]}
                          onChange={(e) => {
                            formik.setFieldValue(
                              `beneficiarios[${index}].edad`,
                              e.target.value
                            )
                          }}
                        />
                      </div>
                      <div className="mb-1">
                        <Label className="form-label" htmlFor="sexo">
                          Sexo
                        </Label>

                        <Select
                          id="sexo"
                          className="react-select w-25"
                          classNamePrefix="select"
                          defaultValue={sexo[0]}
                          value={
                            formik.values.beneficiarios[index].sexo != ""
                              ? {
                                  label:
                                    formik.values.beneficiarios[index].sexo,
                                  value: formik.values.beneficiarios[index].sexo
                                }
                              : sexo[0]
                          }
                          onChange={(e) => {
                            formik.setFieldValue(
                              `beneficiarios[${index}].sexo`,
                              e.value
                            )
                          }}
                          options={sexo}
                          isClearable={false}
                          isSearchable={false}
                        />
                      </div>
                      <div className="mb-1">
                        <Label className="form-label" htmlFor="estatura">
                          Estatura
                        </Label>
                        <Input
                          id="estatura"
                          type="number"
                          value={formik.values.beneficiarios[index]["estatura"]}
                          onChange={(e) => {
                            formik.setFieldValue(
                              `beneficiarios[${index}].estatura`,
                              e.target.value
                            )
                          }}
                        />
                      </div>
                      <div className="mb-1">
                        <Label className="form-label" htmlFor="peso">
                          Peso
                        </Label>
                        <Input
                          id="peso"
                          type="number"
                          value={formik.values.beneficiarios[index]["peso"]}
                          onChange={(e) => {
                            formik.setFieldValue(
                              `beneficiarios[${index}].peso`,
                              e.target.value
                            )
                          }}
                        />
                      </div>
                      <div className="mb-1">
                        <Label className="form-label" htmlFor="fuma">
                          ¿Fuma?
                        </Label>
                        <Select
                          className="react-select w-25"
                          classNamePrefix="select"
                          defaultValue={respuestaSiNo[0]}
                          value={{
                            label: formik.values.beneficiarios[index].fuma,
                            value: formik.values.beneficiarios[index].fuma
                          }}
                          onChange={(e) => {
                            formik.setFieldValue(
                              `beneficiarios[${index}].fuma`,
                              e.value
                            )
                          }}
                          options={respuestaSiNo}
                          isClearable={false}
                          isSearchable={false}
                        />
                      </div>
                      <div className="mb-1">
                        <Label className="form-label">
                          ¿Padece de diabetes?
                        </Label>

                        <Select
                          className="react-select w-25"
                          classNamePrefix="select"
                          defaultValue={respuestaSiNo[0]}
                          value={{
                            label: formik.values.beneficiarios[index].diabetes,
                            value: formik.values.beneficiarios[index].diabetes
                          }}
                          onChange={(e) => {
                            formik.setFieldValue(
                              `beneficiarios[${index}].diabetes`,
                              e.value
                            )
                          }}
                          options={respuestaSiNo}
                          isClearable={false}
                          isSearchable={false}
                        />
                      </div>
                      <div className="mb-1">
                        <Label className="form-label">
                          ¿Tiene algún padecimiento pre-existente?
                        </Label>

                        <Select
                          className="react-select w-25"
                          classNamePrefix="select"
                          defaultValue={respuestaSiNo[0]}
                          value={{
                            label:
                              formik.values.beneficiarios[index].padecimiento,
                            value:
                              formik.values.beneficiarios[index].padecimiento
                          }}
                          onChange={(e) => {
                            formik.setFieldValue(
                              `beneficiarios[${index}].padecimiento`,
                              e.value
                            )
                          }}
                          options={respuestaSiNo}
                          isClearable={false}
                          isSearchable={false}
                        />
                      </div>
                      <div className="mb-1">
                        <Label className="form-label" htmlFor="parentezco">
                          Parentezco
                        </Label>

                        <Select
                          className="react-select w-25"
                          classNamePrefix="select"
                          defaultValue={parentezco[0]}
                          value={
                            formik.values.beneficiarios[index].parentezco !== ""
                              ? {
                                  label:
                                    formik.values.beneficiarios[index]
                                      .parentezco,
                                  value:
                                    formik.values.beneficiarios[index]
                                      .parentezco
                                }
                              : parentezco[0]
                          }
                          onChange={(e) => {
                            formik.setFieldValue(
                              `beneficiarios[${index}].parentezco`,
                              e.value
                            )
                          }}
                          options={parentezco}
                          isClearable={false}
                          isSearchable={false}
                        />
                      </div>
                    </AccordionBody>
                  </AccordionItem>
                </UncontrolledAccordion>
                <div>
                  <XCircle
                    color="red"
                    className="cursor-pointer"
                    onClick={() => eliminarBeneficiario(index)}
                    size={"25px"}
                  />{" "}
                </div>
              </div>
            ))}

          <Button
            className="d-block my-2 btn-success"
            onClick={() => {
              agregarBeneficiario()
            }}
          >
            <Plus size={"15px"} />
            {"  "}
            Agregar beneficiario
          </Button>
        </div>
      </div>

      <div className="d-flex justify-content-end">
        <Button className="m-1" color="primary" onClick={formik.handleSubmit}>
          {props.accion === 1 ? "Guardar" : "Guardar cambios"}
        </Button>
      </div>
    </div>
  )
}

export default PlanMedicoIndividualForm
